export default __webpack_public_path__ + "static/media/messenger-inbox.84ccb2e6.jpg";